class LineItemCollection extends App.Collections.BaseCollection {
    url = 'LineItem';
    model = App.Models.LineItem;
}

App.Collections.LineItems = LineItemCollection;
